<template>
    <div class="city-confirm city-confirm--mobile">
        <div v-if="selectedCity.name" class="city-confirm__title">Ваш город {{ selectedCity.name }}?</div>
        <div class="city-confirm__btns">
            <a href="javascript:void(0);" @click.prevent="confirm()" class="btn btn_red age_popup_btn age_popup_btn--agree">Да</a>
            <a href="javascript:void(0);" @click.prevent="decline()" class="btn btn_transparent age_popup_btn age_popup_btn--disagree">Нет</a>
        </div>
    </div>
</template>

<script>
export default {
    name : 'CityConfirm',
    mounted () {

    },
    methods : {
        confirm () {
            vxCommonStore.commit('setUserCityId', this.selectedCity.id);
            vxCommonStore.commit('setCityConfirmed', true);
        },
        decline () {
            this.$root.showCitySelect();
        },
    },
    computed : {
        selectedCity () {
            let city = this.$store.state.regionsData.cities.filter(o => o.id == vxCommonStore.state.userCityId);
            return city.length ? city[0] : {};
        },
    },
}
</script>
